<template>
    <div class="activityOutcomeContainer">
        <template v-if="isCompleted">
            <span class="learnosity-report" id="sessionDetailByItemReport"></span>
        </template>
        <template v-else>
            <div class="mt-3 mb-3 text-center">
                <span>This quest is still in progress.</span> 
            </div>
        </template>
    </div>
</template>

<script>
  /* global LearnosityItems LearnosityReports:true */
  import { mapActions } from 'vuex'
  export default {
    name: 'classActivityOutcome',
    props: ['activityOutcomeParameter'],
    data () {
      return {
        reportsApp: {},
        scoringObjects: {},
        itemsAppTeacherScoring: {},
        careerIdeaAndConnection: {},
        isCompleted: true
      }
    },
    mounted () {
      this.loadClassAttemptReportForUser()
    },

    methods: {
      ...mapActions([
        'showClassAttemptReportForUser',
        'launchManuallyGradedReportWizardForUser',
        'loadCareerIdeaAndConnectionForUser'
      ]),

      loadClassAttemptReportForUser () {
        const userId = this.activityOutcomeParameter.userId
        const courseId = this.activityOutcomeParameter.courseId
        const sessionId = this.activityOutcomeParameter.sessionId
        this.loadCareerIdeaAndConnectionForUser({courseId: courseId, userId: userId, isMainQuest: true}).then(res => {
          if (res) {
            this.careerIdeaAndConnection = res
          }
        })
        this.showClassAttemptReportForUser({userId: userId, sessionId: sessionId, courseId: courseId}).then(data => {
          if (data) {
            let isClearlyNextCourse = data.isClearlyNextCourse
            if (isClearlyNextCourse) {
              this.isCompleted = this.activityOutcomeParameter.isCompleted
              if (this.isCompleted) {
                this.initializeLearnosityReports(data)
              }
            } else {
              this.initializeLearnosityReports(data)
            }
          }
        })
      },

      initializeLearnosityReports (data) {
        const signedRequest = JSON.parse(data.signedRequest)
        this.reportsApp = LearnosityReports.init(signedRequest, {
          'readyListener': () => {
            this.bindReadyListener(data)
          },
          'errorListener': (event) => {
            console.log('error: ', event)
          }
        })
      },

      bindReadyListener (data) {
        let careerCriteriaList = []
        let isClearlyNextCourse = data.isClearlyNextCourse
        let userCareerCriteriaList = data.userCareerCriteriaList
        let report = this.reportsApp.getReport('sessionDetailByItemReport')
        if (isClearlyNextCourse) {
          report.on('ready:questionsApi', (questionsApp) => {
            let elem = '.lrn-well'
            $(elem).hide()
            $(elem).next().hide()
            $('table').hide()
            $('table.table-bordered').show()
            $('table.lrn_choicematrix_type_table').show()
            $('.lrn_ratingInfo_icon_wrap').hide()
            $('h3.lrn-report-question-title').hide()
            setTimeout(() => {
              let pos = 0
              let questions = questionsApp.questions()
              $.each(questions, (responseId, questionObject) => {
                let question = questionObject.getQuestion()
                if (question.type === 'orderlist') {
                  let selector = '#' + responseId + ' > div.lrn_response_wrapper > div.lrn_response'
                  $(selector).find('.lrn_correct').each(function () {
                    $(this).removeClass('lrn_correct')
                  })
                  $(selector).find('.lrn_incorrect').each(function () {
                    $(this).removeClass('lrn_incorrect')
                  })
                  careerCriteriaList = this.populateUserCareerCriteriaList(questionsApp, question)
                } else {
                  if (careerCriteriaList.length > 0) {
                    this.reorderLabelsBasedOnUserCareerCriteriaList(question, careerCriteriaList)
                  }
                  if (Object.keys(this.careerIdeaAndConnection).length > 0) {
                    this.showCareerIdeaAndConnection(question, this.careerIdeaAndConnection)
                  }
                  if (userCareerCriteriaList && userCareerCriteriaList.length > 0) {
                    let stimulus = question.stimulus
                    if (stimulus) {
                      pos = this.showUserCareerCriteriaList(question, userCareerCriteriaList, pos)
                    }
                  }
                }
              })
            }, 0)
          })
        } else if (this.activityOutcomeParameter.manuallyGraded) {
          this.bindReadyListenerManuallyGraded(report)
        }
      },

      populateUserCareerCriteriaList (questionsApp, question) {
        let careerCriteriaList = []
        let responses = questionsApp.getResponses()
        let response = responses[question.response_id]
        let elems = (question && question.list) ? question.list : []
        let values = (response && response.value) ? response.value : []
        if (Array.isArray(values) && values.length > 0) {
          $.each(values, (i, value) => {
            let elem = elems[value]
            careerCriteriaList.push(elem)
          })
        } else {
          $.each(elems, (i, elem) => {
            careerCriteriaList.push(elem)
          })
        }
        return careerCriteriaList
      },

      reorderLabelsBasedOnUserCareerCriteriaList (question, careerCriteriaList) {
        let order = 0
        let selector = '#' + question.response_id + ' > div.lrn_response_wrapper > div.lrn_response > div.lrn-response-validation-wrapper > div.lrn_cloze_response_container > div.lrn_response_innerbody > div.lrn_response_input > div > p > span:first-child'
        $(selector).each((i, elem) => {
          let source = careerCriteriaList[order]
          let target = this.replaceWhiteSpace($(elem).text())
          let index = careerCriteriaList.findIndex((x) => this.replaceWhiteSpace($(x).text()) === target)
          if (index !== -1) {
            $(elem).html(source)
            order++
          }
        })
      },

      replaceWhiteSpace (label) {
        return label.replace(/\s+/g, '').toLowerCase()
      },

      showUserCareerCriteriaList (question, careerCriteriaList, pos) {
        let selector = '#' + question.response_id + ' > div.lrn_question > div.lrn_stimulus > div.lrn_stimulus_content'
        $(selector).children().each(function (i) {
          let text = $(this).text()
          if (text.toLowerCase().indexOf('criteria ') === 0) {
            let label = careerCriteriaList[pos].label
            let value = careerCriteriaList[pos].value
            if (value) {
              $(this).html(label + '<br/>' + value)
            } else {
              $(this).html(label)
            }
            pos += 1
          }
        })
        return pos
      },

      showCareerIdeaAndConnection (question, careerIdeaAndConnection) {
        let self = this
        let parent = '#' + question.response_id + ' > div.lrn_response_wrapper > div.lrn_response > div.lrn-response-validation-wrapper > div.lrn_cloze_response_container > div.lrn_response_innerbody > div.lrn_response_input > div > table.table-bordered > tbody > tr:eq(1)'
        $(parent).children().each(function (i) {
          let text = $(this).text()
          if (text === '#name') {
            let value = careerIdeaAndConnection.firstName + ' ' + careerIdeaAndConnection.lastName
            let elem = '<span id="name">' + (value || '') + '</span>'
            $(this).html(elem)
          } else if (text === '#organization') {
            let value = careerIdeaAndConnection.organization
            let elem = '<span id="organization">' + (value || '') + '</span>'
            $(this).html(elem)
          } else if (text === '#careeridea') {
            let value = careerIdeaAndConnection.title
            let elem = '<span id="title">' + (value || '') + '</span>'
            $(this).html(elem)
          } else if (text === '#date') {
            let millis = careerIdeaAndConnection.meetingDate
            let value = self.changeMillisToDate(millis)
            let elem = '<span id="meetingDate">' + (value || '') + '</span>'
            $(this).html(elem)
          }
        })
      },

      changeMillisToDate (millis) {
        if (millis) {
          let date = new Date(millis)
          let months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
          return months[date.getMonth()] + '/' + date.getDate() + '/' + date.getFullYear()
        }
        return 'N/A'
      },

      bindReadyListenerManuallyGraded (report) {
        var itemReferences = []
        report.on('ready:itemsApi', (itemsApp) => {
          itemsApp.getQuestions((questions) => {
            $.each(questions, (index, question) => {
              if ((question.metadata.valid_response_count === 0) && (question.metadata.rubric_reference !== undefined)) {
                var reference = question.metadata.rubric_reference
                var itemId = question.response_id + '_' + reference
                this.scoringObjects[itemId] = question
                itemReferences.push({'id': itemId, 'reference': reference})

                $('<span class="learnosity-item" data-reference="' + itemId + '">')
                  .appendTo($('#' + question.response_id).closest('.row')).wrap('<div class="teacher_scoring"></div>')
                  // .appendTo($('#' + question.response_id)).wrap('<div class="teacher_scoring"></div>')
              }
            })
          })

          if (itemReferences.length > 0) {
            var itemsActivity = {
              'state': 'review',
              'type': 'feedback',
              'items': itemReferences,
              'rendering_type': 'inline',
              'user_id': this.activityOutcomeParameter.userId,
              'session_id': this.activityOutcomeParameter.sessionId,
              'activity_id': this.activityOutcomeParameter.activityId
            }

            this.launchManuallyGradedReportWizardForUser(itemsActivity).then(data => {
              if (data) {
                var self = this
                self.itemsAppTeacherScoring = LearnosityItems.init(data, {
                  readyListener: function () {
                    self.generateScoreStimulus()
                  }
                })
              }
            })
          }
        })
      },

      generateScoreStimulus () {
        $.each(this.itemsAppTeacherScoring.getItems(), (index, item) => {
          const question = this.scoringObjects[index]
          const text = 'Enter score between 0-' + ((question.validation && question.validation.max_score) ? question.validation.max_score : 1)
          const elemId = 'stimulus-' + item.response_ids[0]
          $('#' + elemId).text(text)
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/app/assessment/components/ClassActivityOutcome.vue